import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatSection } from './chat-section';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState, useMemo, useRef } from 'react';
import { useCompanyContext } from '../../../application/context/CompanyContext';
import { useAppDispatch, useAppSelector } from '../../../application/store/useStore';
import { getClausesAsync, getAnalysisAsync, initiateChatAsync } from '../../../application/features/chat/chatThunk';
import { getProposalDocsAsync } from '../../../application/features/proposalDocument/proposalDocumentThunk';
import { getProposalsAsync } from '../../../application/features/proposal/proposalThunk';
import { Drawer, IconButton, Stack, useMediaQuery, useTheme, ThemeProvider, createTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { TableOfContents } from './table-contents';
import { Icon } from '@iconify/react';
import ChatReference from './chat-reference';
import { nanoid } from '@reduxjs/toolkit';
import { palette } from '../../../theme/palette';
import { customShadows } from '../../../theme/custom-shadows';
import { shadows } from '../../../theme/shadows';
import { typography } from '../../../theme/typography';
export default function Chat() {
    const [searchParams] = useSearchParams();
    const theme = useTheme();
    const navigate = useNavigate();
    const proposalId = searchParams.get('id');
    const dispatch = useAppDispatch();
    const { selectedCompanyId } = useCompanyContext();
    // Store the initial company ID when chat page loads
    const initialCompanyIdRef = useRef(null);
    const [currentTheme, setCurrentTheme] = useState('light');
    // Create dark theme for ChatSection
    const localTheme = useMemo(() => createTheme({
        palette: palette(currentTheme),
        shadows: shadows(currentTheme),
        customShadows: customShadows(currentTheme),
        typography,
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536
            }
        },
        shape: { borderRadius: 8 }
    }), []);
    const [chatData, setChatData] = useState(null);
    const [clausesData, setClausesData] = useState(null);
    const [analysisData, setAnalysisData] = useState(null);
    const { allProposals, proposal } = useAppSelector((state) => state.proposal);
    const [isDocumentView, setIsDocumentView] = useState(false);
    const [isZoomView, setisZoomView] = useState(false);
    const [sources, setSources] = useState([]);
    const [initialreferenceSource, setInitialReferenceSource] = useState();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [tableOfContentdrawerOpen, setTableOfContentDrawerOpen] = useState(false);
    const [chatReferencedrawerOpen, setChatReferenceDrawerOpen] = useState(false);
    // useEffect(() => {
    //   const newSources: DocumentSourceDto[] = sources.map((doc) => ({
    //     document: doc.document_id,
    //     documentName: doc.document,
    //     page: doc.page,
    //     filepath: doc.filepath,
    //     content:doc.content,
    //     bbox: doc.bbox,
    //     doc_content_id: doc.doc_content_id,
    //     // height: 800,
    //     // width: 600
    //   }));
    //   setSources(newSources);
    // }, [documentContent]);
    const [changeAnswerRequest, setChangeAnswerRequest] = useState(null);
    // Set initial company ID when component mounts
    useEffect(() => {
        if (selectedCompanyId && !initialCompanyIdRef.current) {
            initialCompanyIdRef.current = selectedCompanyId;
        }
    }, [selectedCompanyId]);
    // Redirect to proposal grid when company changes
    useEffect(() => {
        if (initialCompanyIdRef.current &&
            selectedCompanyId &&
            initialCompanyIdRef.current !== selectedCompanyId) {
            // Company has changed, redirect to proposal grid
            navigate('/proposal');
        }
    }, [selectedCompanyId, navigate]);
    useEffect(() => {
        if (proposalId) {
            dispatch(getProposalsAsync());
            dispatch(getProposalDocsAsync(proposalId));
            dispatch(initiateChatAsync(proposalId))
                .unwrap()
                .then((response) => {
                setChatData(response);
            })
                .catch((error) => { });
            // Fetch clauses data
            dispatch(getClausesAsync({ proposalId }))
                .unwrap()
                .then((response) => {
                setClausesData(response);
            })
                .catch((error) => { });
            // Fetch analysis data
            dispatch(getAnalysisAsync(proposalId))
                .unwrap()
                .then((response) => {
                setAnalysisData(response);
            })
                .catch((error) => { });
        }
    }, [dispatch, proposalId]);
    // Function to handle change in answer
    const handleChangeAnswer = (clauseNo, questionNo, clauseId, questionId, answer, clauseName) => {
        setIsDocumentView(false);
        if (proposalId) {
            const changeAnswerRequestData = {
                ProposalId: proposalId,
                ClauseNo: clauseNo,
                QuestionNo: questionNo,
                ClauseId: clauseId,
                QuestionId: questionId,
                Instruction: '',
                ClauseName: clauseName
            };
            setChangeAnswerRequest(changeAnswerRequestData);
        }
    };
    const resetChangeAnswerRequest = () => {
        setChangeAnswerRequest(null);
    };
    const openDocumentView = () => {
        setIsDocumentView(true);
    };
    const onReferenceClick = (source, sources) => {
        setIsDocumentView(false);
        setInitialReferenceSource(source);
        console.log('source document content id', source);
        setSources(sources);
        setIsDocumentView(true);
    };
    const onZoomClick = () => {
        setisZoomView(false);
    };
    const onZoomToggle = () => {
        setisZoomView((prev) => !prev);
    };
    return (_jsxs(Stack, { flexDirection: 'row', width: '100%', sx: {
            padding: '8px 0px 12px 0px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            position: 'relative',
            gap: 16,
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'url("/bg.png")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                filter: 'blur(3px)',
                opacity: 0.5,
                zIndex: -1
            }
        }, children: [isSmallScreen && !chatReferencedrawerOpen && (_jsx(IconButton, { onClick: () => setTableOfContentDrawerOpen(true), sx: { position: 'absolute', top: 22, left: 8 }, children: _jsx(Icon, { icon: 'la:list-ul', width: 24, height: 24, color: 'default' }) })), _jsx(Drawer, { anchor: 'left', sx: { width: '100%' }, open: tableOfContentdrawerOpen, onClose: () => setTableOfContentDrawerOpen(false), children: _jsx(TableOfContents, { resetChangeAnswerRequest: resetChangeAnswerRequest, chatData: chatData, clausesData: clausesData, analysisData: analysisData, onReferenceClick: onReferenceClick, handleChangeAnswer: handleChangeAnswer, onCloseDrawer: () => setTableOfContentDrawerOpen(false), changeAnswerRequest: changeAnswerRequest }) }), _jsxs(Grid, { container: true, width: '100%', columnSpacing: 2, children: [!isSmallScreen && (_jsx(Grid, { size: { xs: 6, lg: isZoomView ? 4 : 7 }, children: _jsx(TableOfContents, { onReferenceClick: onReferenceClick, resetChangeAnswerRequest: resetChangeAnswerRequest, chatData: chatData, clausesData: clausesData, analysisData: analysisData, onZoom: isZoomView, handleChangeAnswer: handleChangeAnswer, changeAnswerRequest: changeAnswerRequest }) })), !isDocumentView && (_jsx(Grid, { size: { xs: 12, lg: isZoomView ? 8 : 5 }, children: _jsx(ThemeProvider, { theme: localTheme, children: _jsx(ChatSection, { onReferenceClick: onReferenceClick, changeAnswerRequest: changeAnswerRequest, resetChangeAnswerRequest: resetChangeAnswerRequest }) }) })), isDocumentView && (_jsx(Grid, { size: { xs: 12, lg: isZoomView ? 8 : 5 }, children: initialreferenceSource && (_jsx(ChatReference, { onZoomToggle: onZoomToggle, setZoomView: onZoomClick, onReferenceClick: onReferenceClick, open: true, onClose: () => setIsDocumentView(false), sources: sources, hash_id: initialreferenceSource.doc_content_id != null
                                ? initialreferenceSource.doc_content_id
                                : initialreferenceSource.chunk_id, scroll_id: nanoid(), currentSource: initialreferenceSource })) }))] })] }));
}
